<ng-container *transloco="let t">
  <div class="subheader">
    <h1>{{ t('common.forbidden') }}</h1>
  </div>
  <div class="content">
    <div class="block padding">{{ t('common.forbiddenMessage') }}</div>
  </div>
</ng-container>
